var _circle, _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndividual(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 24,
    cy: 76,
    r: 24,
    fill: "#94D8ED"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.31 31.7a9.6 9.6 0 100-19.2 9.6 9.6 0 000 19.2z",
    fill: "#95D8ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.31 31.7a9.6 9.6 0 100-19.2 9.6 9.6 0 000 19.2z",
    stroke: "#25557B",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.31 34.14v15.14c0 4.22 2.7 6.48 4.98 9.23 2.13 2.55 3.26 5.05 7.02 5.05s4.89-2.5 7.02-5.05c2.29-2.75 4.98-5.01 4.98-9.23V34.14c0-5.36-24-5.36-24 0z",
    fill: "#fff",
    stroke: "#25557B",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.32 50.69h3.84l1.67-3.66c.28-.62.35-1.34.13-1.99-.45-1.37-1.61-2.35-2.96-2.35h-2.68",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.24 26.52c-5.87 0-16.71-.75-17.74 16.9 0 0 3.18-5.86 8.14-5.86 4 0 10.38.31 12.68-5.49l.07.51s3.74 8.44 10.67 8.98c0 0 1.16-9.6-6.35-13.46-1.89-.97-4.33-1.58-7.47-1.58z",
    fill: "#95D8ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.24 26.52c-5.87 0-16.71-.75-17.74 16.9 0 0 3.18-5.86 8.14-5.86 4 0 10.38.31 12.68-5.49l.07.51s3.74 8.44 10.67 8.98c0 0 1.16-9.6-6.35-13.46m4.32 22.59h2.13l1.67-3.66c.28-.62.35-1.34.13-1.99-.45-1.37-1.61-2.35-2.96-2.35h-.68m-14.36 21.3c-.05 3.49-1.26 6.96-3.41 9.72m9.36-6.72c-.49 2.54 1.15 4.92 2.3 5.97m-16.28 2.55c2.77 2.43 6.4 3.91 10.38 3.91 3.98 0 7.61-1.48 10.38-3.91",
    stroke: "#25557B",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.31 49.04s.49 1.52-.34 2.93c0 0 1.62.43 3.07-.43",
    stroke: "#25557B",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 76c-3.167.167-10 2.2-12 9m41-9c3.167.167 10 2.2 12 9",
    stroke: "#25557B",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M30 11h36.59v69.93H30z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndividual);
export default __webpack_public_path__ + "static/media/individual.381b7f929b7a8246f8298f06126beaa5.svg";
export { ForwardRef as ReactComponent };